import { Suspense, lazy } from 'react';
import { Preloader } from './Preloader';

const ReactPlayer = lazy(() => import('react-player'));

interface Props {
    url: string;
    width?: number;
    height?: number
    controls?: boolean
}

export const Player = ({ url, width, height, controls = true }: Props) => {
    return (
        <div className="position-relative">
            <Suspense fallback={<Preloader inProgress={true} />}>
                <ReactPlayer
                    src={url}
                    width={width}
                    height={height}
                    controls={controls}
                />
            </Suspense>
        </div>
    )
}
